import { imagePrefix } from '../constants'

// TODO: need to fix this in server
const localhostUrl = 'http://localhost/'

const getAvatarUrl = (picture) => {
  try {
    if (!picture) {
      return ''
    }

    if (picture.startsWith(localhostUrl)) {
      return picture.replace(localhostUrl, imagePrefix + '/')
    }

    return picture
  } catch (e) {
    console.log(e)
    return ''
  }
}

export default getAvatarUrl
